import React, { useState, useEffect } from 'react';
import { Tooltip } from 'antd';
import { Button } from 'react-bootstrap';
import star from '../../images/star.svg';
import emptyIconProfile from '../../images/emptyIconProfile.svg';
import styled from "styled-components";
import { RegistrationAsManagerIsRequired } from '../Modals/RegistrationAsManagerIsRequired';
import { Candidate } from '../../types';

const NameCard = styled.h1`
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 25px;
    display: inline-block;
    color: #2196F3;
    cursor: pointer;
    margin-bottom: 4px;
`

const NameCardView = styled.h1`
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 25px;
    display: inline-block;
    color: #BB6BD9;
    cursor: pointer;
    margin-bottom: 4px;
`

type CandidateCardForNotAuthorizedProps = {
    candidate: Candidate,
    children?: any,
    link?: string,
    isView?: boolean
}

export const CandidateCardForNotAuthorized = ({ candidate, children, link, isView = false }: CandidateCardForNotAuthorizedProps) => {
    const find = false;
    const [isModalOpen, setIsModalOpen] = useState(false);
  
    const showModal = () => {
        setIsModalOpen(true);
    }
  
    const closeHandler = () => {
        setIsModalOpen(false);
    }

    return (
        <>
            <div className="candidate-card" key={candidate.id}>
                <div className="different-edges-container" style={{marginBottom: '24px'}}>
                    <div className="left-edge">
                        <img src={emptyIconProfile} className="avatar" style={{marginRight:'16px'}} key={candidate.avatarId}/>
                    </div>
                    <div className="left-edge">
                        <div className="header-card" onClick={showModal}>
                            {(isView) ? <NameCardView> {candidate.fullName} </NameCardView> : <NameCard> {candidate.fullName} </NameCard>}
                            {(find) && <div className="find-candidate-card"> Ищу работу, стажировку </div>}
                        </div>
                        <div>
                            <div className="row-container">
                                <img src={star} width="16px" style={{marginTop:'-5px'}}/>
                                <p className="hours-number" style={{ marginBottom: '4px' }}>
                                    {candidate.ratingRTSIM}
                                </p>
                                <Tooltip placement='bottom'
                                title="Рейтинг РТСИМ - рейтинг, основанный на данных по использованию компьютерных тренажеров РТСИМ.Карьера.">
                                    <h6 style={{ marginBottom: '4px' }}>
                                        Рейтинг РТСИМ
                                    </h6>
                                </Tooltip>
                            </div>
                            <p style={{ marginBottom: '4px' }}> {candidate.educationalInstitution} </p>
                            {(candidate.specialtyNumber || candidate.specialtyName) && <p style={{ marginBottom: '4px' }}> {candidate.specialtyNumber}&nbsp;{candidate.specialtyName} </p>}
                            <p> {candidate.city} </p>
                        </div>
                    </div>
                </div>
                <div className="different-edges-container">
                    <div className="left-edge">
                        <Button style={{height:'32px', padding: '5px 16px'}} onClick={showModal}> Пригласить </Button>
                    </div>
                </div>
            </div>
            <RegistrationAsManagerIsRequired isOpen={isModalOpen} close={closeHandler}/>
        </>
    )
}